// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__qn4eh","error":"Input_error__uztDr"};